export default __webpack_public_path__ + "static/winner-bg-img-3-470a7883bad9091655464ed37d55e203.png";